<template>
  <base-page :title="$t('l.pusher_account')" icon="ios-contacts">
    <Row type="flex" justify="end" slot="extra">
      <Col class="margin-right-10 flex-align-center">
        <span>{{$t("l.select_push_city")}}：</span>
        <Select @on-change="loadData(1)" v-model="tableData.page.pusher_label" style="width:200px">
          <Option value="" key="">全部</Option>
          <Option v-for="item in pusherList" :value="item.label" :key="item.label">{{ item.name }}</Option>
        </Select>
      </Col>
      <Col class="flex-align-center">
        <span>{{$t("l.remark252")}}？</span>
        <i-switch size="small" v-model="tableData.page.usernameIsEmpty" :true-value="1" :false-value="0" @on-change="loadData(1)">{{ $t('l.fresh') }}</i-switch>
      </Col>

      <Col class="margin-left-5">
        <Button type="primary" @click="loadData(1)">{{ $t('l.fresh') }}</Button>
      </Col>
      <Col class="margin-left-5">
        <Input class="search-keyword" v-model="tableData.page.keyword" search suffix="ios-search"
               :placeholder="$t('l.remark251')"
               @on-change="loadData(1)"/>
      </Col>
    </Row>
      <Row class="full">
        <Col span="24" class="owner-table">
          <Table stripe border
                 :loading="tableData.loading"
                 :columns=getColumns
                 :data="tableData.data">
          </Table>
          <Row type="flex" justify="center">
            <Col>
              <Page size="small"
                    :current.sync="tableData.page.current"
                    :page-size="tableData.page.size"
                    :total="tableData.page.total"
                    :page-size-opts="tableData.page.sizeOptions"
                    show-elevator show-sizer show-total
                    @on-page-size-change="loadData(1)"
                    @on-change="loadData(tableData.page.current)">
              </Page>
            </Col>
          </Row>
        </Col>
      </Row>
    <!--  弹框-->
    <lg-modal :title="$t('l.edit')" :show="modal.show" :loading="modal.loading"
              @on-submit="onSubmit"
              @on-cancel="modal.loading=false; modal.show = false;">
      <Form :model="modal.pusher" :label-width="80" ref="modal"
            >
        <FormItem :label="$t('l.account')">
          <Input v-model="modal.pusher.username"/>
        </FormItem>
        <FormItem :label="$t('l.secretKey')" >
          <Input v-model="modal.pusher.password"/>
        </FormItem>
      </Form>
    </lg-modal>
    </base-page>
</template>

<script>
import basePage from "../my-components/base-page"
import util from "../../libs/util"
import lgModal from "../my-components/lg-modal"

export default {
  name: "page_owner",
  components: {
    basePage,
    lgModal,
  },
  data() {
    return {
      pusherList:[],
      tableData: {
        columns: [],
        data: [],  // 所有数据
        page: {
          current: 1,  // 当前页码
          size: 10, // 每页个数
          sizeOptions: [10, 20, 30],
          total: 0,
          sortKey: 'create_time',
          sortMethod: 'desc',
          keyword: '',
          usernameIsEmpty:1,
          pusher_label:''
        }, // 当前页
        size: 10, // m每页大小
        loading: false
      },
      modal:{
        show:false,
        loading:false,
        pusher:{
          username:'',
          password:'',
          code:''
        }
      }
    }
  },
  methods: {
    loadData(page) {  //   获取信息
      this.tableData.loading = true
      this.tableData.page.current = page || this.tableData.page;
      console.log(this.tableData.page.current);
      util.ajax.post("/push/accountList", this.tableData.page).then(res => {
        if (!res.code) {
          this.setPage(res.data)
        }
        this.tableData.loading = false
      })
    },
    loadPusherOPtions(){
      util.ajax.post("/push/getAllPusher", this.tableData.page).then(res => {
          this.pusherList = res.data;
      })
    },
    setPage(pageInfo) {
      if (pageInfo) {
        pageInfo.list.forEach((owner, index) => {
          util.parseJSONResult(owner);
          owner.index = index
        })
        this.tableData.data = pageInfo.list;
        if (pageInfo.pageNumber) this.tableData.page.current = pageInfo.pageNumber;
        if (pageInfo.totalRow) this.tableData.page.total = pageInfo.totalRow;
      }
    },
    onSubmit(){
      util.ajax.post("/push/savePusherAccount", this.modal.pusher).then(res => {
        if(!res.code){
          this.$Message.success(this.$t("l.success"));
          this.modal.show = false;
          this.loadData(1);
        }
      })
    },
  },
  computed: {
    getColumns() {
      return [
        {
          title: this.$t('l.select_push_city'),
          key: "name",
          align: "center",
        },
        {
          title: this.$t('l.account'),
          key: "username",
          align: "center",
        },
        {
          title: this.$t('l.secretKey'),
          key: "password",
          align: "center",
        },
        {
          title: this.$t('l.lift_factory'),
          key: "factory_name",
          align: "center",
        },
        {
          title: this.$t('l.region_select'),
          key: "push_label",
          align: "center",
        },
        {
          title: this.$t('l.push_scheme'),
          key: "code",
          align: "center",
        },
        {
          title: this.$t('l.operation'),
          key: "action",
          fixed: 'right',
          align: "center",
          render: (h, params) => {
            let row = params.row;
            let actionBtns = [];
              actionBtns.push(h('Button', {
              props: {
                type: 'primary',
                size: 'small'
              },
              style: {
                marginRight: '8px'
              },
              on: {
                click: () => {
                  this.modal.show = true;
                   this.modal.pusher.username = row.username;
                   this.modal.pusher.password = row.password;
                  this.modal.pusher.code = row.code;
                },
              }
            }, this.$t("l.edit")));

            return h('ButtonGroup', actionBtns)
          }
        },
      ]
    },
    getFormRules() {
      return {
        'pusher.username': [
            {required: true, message: this.$t('l.remark33'), trigger: 'blur'}
        ],
        'pusher.password': [
          {required: true, message: this.$t('l.remark33'), trigger: 'blur'}
        ],
      }
    },
  },
  created() {
    this.loadData(1);
    this.loadPusherOPtions();
  }
}
</script>

<style scoped lang="less">
</style>